// src/theme/colorModeStorage.js

export const COLOR_MODE_AUTH_EVENT = 'genweb:auth';

const STORAGE_PREFIX = 'genweb.colorMode:';

export function getColorModeUserKey() {
    try {
        return localStorage.getItem('userKey') || 'anonymous';
    } catch {
        return 'anonymous';
    }
}

function storageKey(userKey = getColorModeUserKey()) {
    return `${STORAGE_PREFIX}${userKey || 'anonymous'}`;
}

/**
 * @returns {'light' | 'dark'}
 */
export function readStoredColorMode(userKey = getColorModeUserKey()) {
    try {
        const raw = localStorage.getItem(storageKey(userKey));
        return raw === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
}

/**
 * @param {'light' | 'dark'} mode
 */
export function writeStoredColorMode(mode, userKey = getColorModeUserKey()) {
    try {
        localStorage.setItem(storageKey(userKey), mode === 'dark' ? 'dark' : 'light');
    } catch {
        // ignore quota / private mode
    }
}

/** Notify ColorModeProvider that userKey / session identity changed. */
export function notifyAuthChanged() {
    try {
        window.dispatchEvent(new Event(COLOR_MODE_AUTH_EVENT));
    } catch {
        // ignore
    }
}
